// extracted by mini-css-extract-plugin
module.exports = {"footer":"Shell_footer__Ls6Rs","main":"Shell_main__dQPvT","inner":"Shell_inner__sC_5j"};